<template>
  <div class="bb-contact-company-form">
    <div class="bb-contact-company-form-item"
         v-if="!input.hide && input.id !== 'companyStamp' && company && (getValue(input) || getValue(input) === 0)"
         v-for="(input) in currentInputs"
         :key="input.id + '' + input.model">
      <div class="bb-contact-company-form-item__label">
        {{getLabel(input)}}
      </div>
      <div class="bb-contact-company-form-item-value" v-if="input.type !== 'stamp'">
        <span :class="{
          'bb-contact-company-form-item-value__date': input.type === 'date'
        }">
          {{getValue(input)}}
        </span>
        <i class="icon-calendar bb-contact-company-form-item-value__calendar" v-if="input.type === 'date'"/>
      </div>
      <div class="bb-contact-company-form-item-value" v-else-if="input.type === 'stamp'">
        <UploadFileForm
          @loader="loader"
          :disabled="true"
          :file-id="getValue(input)"/>
      </div>
    </div>
  </div>
</template>

<script>
import {cloneDeep, get, filter, groupBy, findLastIndex} from 'lodash'
import moment from 'moment'
import UploadFileForm from '@/components/Main/UploadFileForm/UploadFileForm'

export default {
  name: 'ContactCompanyForm',
  components: {UploadFileForm},
  props: ['company', 'inputs'],
  data () {
    return {
      currentInputs: []
    }
  },
  methods: {
    loader (value) {
      this.$emit('loader', value)
    },
    getLabel (input) {
      const suffix = input.suffix || ''
      const numeration = input.numeration || ''
      const label = input.label ? input.label.replace(/\*/, '') : ''
      const result = [label]
      if (numeration) result.push(numeration)
      if (suffix) result.push(suffix)
      return result.join(' ')
    },
    getValue (input) {
      const valueGroup = get(this.company, [input.group, input.counter, input.model], '')
      const valueAlone = get(this.company, input.model, '')
      const value = input.group ? valueGroup : valueAlone
      if (input.type === 'select') {
        return value.name === 0 || value.name ? value.name : ''
      } else if (input.type === 'radio') {
        return value ? 'Yes' : 'No'
      } else if (input.type === 'date') {
        return this.formatDate(value)
      } else if (input.type === 'stamp') {
        return value ? value.id : ''
      } else {
        return value
      }
    },
    setInputs () {
      this.currentInputs = cloneDeep(this.inputs)
      const hasGroups = filter(this.currentInputs, 'group')
      const groups = groupBy(hasGroups, 'group')
      Object.keys(groups).forEach(groupName => {
        const groupCompany = this.company[groupName]
        if (!groupCompany) return
        groupCompany.forEach((groupValue, index) => {
          const newGroup = cloneDeep(groups[groupName]).map(input => {
            input.numeration = index + 1
            input.id += index
            input.counter = index
            return input
          })
          const indexInput = findLastIndex(this.currentInputs, {group: groupName})
          if (indexInput === -1 || index === 0) return
          this.currentInputs.splice(indexInput + 1, 0, ...newGroup)
        })
      })
    },
    formatDate (date) {
      const validDate = moment(date).isValid()
      return validDate ? moment(date).format('DD-MMM-YY') : ''
    }
  },
  watch: {
    company () {
      this.setInputs()
    }
  },
  beforeMount () {
    this.setInputs()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../sass/variables";
  @import "../../../../../../sass/mixins";

  .bb-contact-company-form {
    @include global-font;

    &-item {
      margin: 0 20px;
      padding: 13px 0;
      display: grid;
      grid-template-columns: 1fr auto;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid $color-wild-sand;

      &__label {
        font-weight: 600;
        font-size: 13px;
        line-height: 16px;
        color: $color-accent;
      }

      &-value {
        font-size: 13px;
        line-height: 16px;
        color: $color-black;
        text-align: end;

        &__date {
          line-height: 11px;
        }

        &__calendar {
          font-size: 11px;
          color: $color-accent;
          margin-left: 4px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCompany/ContactCompanyCard/ContactCompanyForm.vue